<template>
    <div>
        <v-card
            class="pa-4"
        >
            <month
                v-model="model.month_from"
                @input="loadMonthBudgetFromOtherMonth"
                :label="label"
            ></month>
            <div
                class="mt-4 d-flex justify-center"
            >
                <v-progress-circular
                    v-if="itemsLoading"
                    indeterminate
                    color="primary"
                    size="20"
                ></v-progress-circular>
                <span
                    v-else
                    style="font-size: 12px;"
                >{{ $t('msg.foundRecords') }}: {{ items.length }}  {{ $t('msg.pcs') }}</span>
            </div>
        </v-card>
        <btns-wrap class="mt-3">
            <c-btn
                color="primary"
                :disabled="items.length === 0"
                :loading="loading"
                @click="submit"
            >{{ $t('msg.toTransfer') }}</c-btn>
        </btns-wrap>
    </div>
</template>

<script>
import {format, addMonths} from 'date-fns';
import Month from "../../../ui/Month";

export default {
    components: {Month},
    props: {
        month: {type: String, required: true}
    },
    data() {
        return {
            model: {
                month_from: format(addMonths(new Date(), -1), 'yyyy-MM'),
                month_to: this.month,
            },
            items: [],
            itemsLoading: false,
            label: this.firstUpperCase(this.$t('msg.transferFrom')),
            loading: false
        }
    },
    methods: {
        loadMonthBudgetFromOtherMonth() {
            this.itemsLoading = true;
            this.$store.dispatch('loadMonthBudgetFromOtherMonth', {
                params: this.model,
            })
                .then(res => this.items = res)
                .finally(() => this.itemsLoading = false);
        },
        submit() {
            this.loading = true;
            this.$store.dispatch('createMonthBudgetsFromOtherMonth', {
                data: this.model,
            })
                .then(() => this.$router.push({name: 'month_budget', query: {month: this.month}}))
                .finally(() => this.loading = false);
        }
    },
    created() {
        this.loadMonthBudgetFromOtherMonth();
    }
}
</script>